import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    confList: [],
    confType: 's'
  },
  getters: {
    currencyList: state => state.currencyList
  },
  mutations: {
    setConfList(state, payload) {
      if(payload instanceof Array) {
        state.confList = payload.slice();
      } else {
        let tempArr = [];
        let r = JSON.parse(payload);
        if(r.value[0] != null) {
          tempArr.push({
            confKey: r.key[0],
            confValue: r.value[0]
          });
        }
        state.confList = tempArr.slice();
      }
    },
    setCt(state, payload) {
      state.confType = payload;
    }
  },
  actions: {
    list({ state, commit }, { searchWords }) {
      if(searchWords === '') return;
      api.getConfList({
        confType: state.confType,
        searchWords
      }).then(({ data }) => {
        commit('setConfList', data || []);
      });
    },
    setConfType({ commit }, data) {
      commit('setCt', data);
    },
    // eslint-disable-next-line
    update({ state, commit }, {k, v}) {
      return new Promise(resolve => {
        api.updateConf({
          confType: state.confType,
          k,
          v
        }).then(res => {
          resolve(res);
        });
      });
    },
    create({ state, commit }, {k, v}) {
      return new Promise(resolve => {
        api.createConf({
          confType: state.confType,
          k,
          v
        }).then(res => {
          resolve(res);
        });
      });
    },
    clearConfList({ commit }) {
      commit('setConfList', []);
    }
  }
};

appStore.registerModule('siteConf', store);
